import React, { useState, useEffect } from "react";
import ReactImageLightbox from "react-image-lightbox"; // Install this for pop-up functionality
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useHistory } from "react-router-dom";

const Home = () => {
  const history = useHistory();
  const [activeFilter, setActiveFilter] = useState("*");
  const portfolioItems = [
    {
      class: "pf-item large-height set-bg wedding",
      image: "img/portfolio/wineglass.jpg",
      title: "COLORS SPEAK",
      category: "Fashion",
    },
    {
      class: "pf-item large-width large-height set-bg fashion",
      image: "img/portfolio/cart.webp",
      title: "COLORS SPEAK",
      category: "Fashion",
    },
    {
      class: "pf-item large-width set-bg lifestyle",
      image: "img/portfolio/vidhansoudha.jpg",
      title: "COLORS SPEAK d",
      category: "Fashion",
    },
    // {
    //   class: "pf-item large-width set-bg natural",
    //   image: "img/portfolio/yoga.jpeg",
    //   title: "COLORS SPEAK f",
    //   category: "Fashion",
    // },

    {
      class: "videos large-width",
      image: "img/portfolio/tribe.jpg",
      title: "COLORS SPEAK",
      category: "Fashion",
    },

    {
      class: "lifestyle large-width large-height",
      image: "img/portfolio/women.png",
      title: "COLORS SPEAK d",
      category: "Fashion",
    },

    // {
    //   class: "lifestyle large-width  large-height",
    //   image: "img/portfolio/bird.jpg",
    //   title: "COLORS SPEAK",
    //   category: "Fashion",
    // },
    {
      class: "natural large-width large-height",
      image: "img/portfolio/flower.jpeg",
      title: "COLORS SPEAK",
      category: "Fashion",
    },
    {
      class: "lifestyle",
      image: "img/portfolio/office.jpg",
      title: "COLORS SPEAK",
      category: "Fashion",
    },
    {
      class: "fashion",
      image: "img/portfolio/temple.jpeg",
      title: "COLORS SPEAK",
      category: "Fashion",
    },

    {
      class: "videos",
      image: "img/portfolio/mysore.jpg",
      title: "COLORS SPEAK",
      category: "Fashion",
    },

    {
      class: "fashion large-width",
      image: "img/portfolio/road.webp",
      title: "COLORS SPEAK",
      category: "Fashion",
    },
    {
      class: "natural large-width ",
      image: "img/portfolio/cars.png",
      title: "COLORS SPEAK",
      category: "Fashion",
    },
    // {
    //   class: "lifestyle",
    //   image: "img/portfolio/office.jpg",
    //   title: "COLORS SPEAK",
    //   category: "Fashion",
    // },

    // {
    //   class: "natural large-width large-height",
    //   image: "img/portfolio/pound.png",
    //   title: "COLORS SPEAK",
    //   category: "Fashion",
    // },
    // {
    //   class: "natural large-width large-height",
    //   image: "img/portfolio/gate.png",
    //   title: "COLORS SPEAK",
    //   category: "Fashion",
    // },
    // {
    //   class: "natural large-width large-height",
    //   image: "img/portfolio/cars.png",
    //   title: "COLORS SPEAK",
    //   category: "Fashion",
    // },
    // {
    //   class: "small-width large-height",
    //   image: "img/portfolio/baloons.jpeg",
    //   title: "COLORS SPEAK",
    //   category: "Fashion",
    // },
    // {
    //   class: "small-width large-height large-width",
    //   image: "img/portfolio/bike.png",
    //   title: "COLORS SPEAK",
    //   category: "Fashion",
    // },
  ];
  const [isOpen, setIsOpen] = useState(false); // For lightbox modal
  const [currentImage, setCurrentImage] = useState(""); // Track the current image for modal

  const openModal = (imgSrc) => {
    setCurrentImage(imgSrc);
    setIsOpen(true);
  };

  const filteredItems =
    activeFilter === "*"
      ? portfolioItems
      : portfolioItems.filter((item) => item.class.includes(activeFilter));

  useEffect(() => {
    const $ = window.$;
    $(document).ready(function () {
      $(".categories-slider").owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        autoplay: true, // Enable auto-scrolling
        autoplayTimeout: 2000, // Auto-scroll interval in milliseconds
        autoplayHoverPause: true, // Pause on hover
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 2,
          },
          1000: {
            items: 5, // Show 4 items on screens larger than 1000px
          },
        },
      });
    });
  }, []);

  const options = {
    loop: true,
    margin: 10,
    nav: true,
    dots: true, // Enable dots (indicators)
    autoplay: true, // Enable auto-scrolling
    autoplayTimeout: 1500, // Auto-scroll interval in milliseconds
    autoplayHoverPause: true, // Pause on hover
    responsive: {
      0: {
        items: 1, // Show 1 item on small screens
      },
      600: {
        items: 2, // Show 2 items on medium screens
      },
      1000: {
        items: 5, // Show 4 items on large screens
      },
    },
  };

  const option = {
    items: 1,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    dots: false,
  };

  const [isMobile, setIsMobile] = useState(false);
  const checkMobile = () => {
    if (window.innerWidth <= 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  const handleImageClick = (category) => {
    history.push({
      pathname: `/clicks`,
      state: { category }, // Passing the category in state
    });
  };

  return (
    <div className="home">
      <section className="hero-section">
        <OwlCarousel className="owl-theme" {...option}>
          <div
            className="hs-item set-bg"
            style={{
              backgroundImage: isMobile
                ? "url(img/hero/mob.jpg)"
                : "url(img/hero/040A1293.jpg)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              backgroundPosition: "top center",
            }}
          ></div>
          <div
            className="hs-item set-bg"
            style={{
              backgroundImage: isMobile
                ? "url(img/hero/landmob.jpg)"
                : "url(img/hero/040A5051.jpg)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              backgroundPosition: "top center",
            }}
          ></div>
          <div
            className="hs-item set-bg"
            style={{
              backgroundImage: isMobile
                ? "url(img/hero/birdMob.jpg)"
                : "url(img/hero/040A8238.jpg)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              backgroundPosition: "top center",
            }}
          ></div>
        </OwlCarousel>
      </section>

      <section
        className="services-section spad"
        style={{ marginTop: isMobile ? "-8rem" : "8rem" }}
      >
        <div className="container">
          <div className="row">
            {[
              {
                title: "Endangered",
                img: "_MG_3257.jpg",
                desc: "The Hoolock gibbon, India's only ape, gracefully swings through the trees of Hollongapar Gibbon Sanctuary. This elusive creature, with its distinctive call and agile movements, is a sight to behold. The sanctuary provides an ideal habitat for these primates, making it a must-visit for wildlife enthusiasts.",
              },
              {
                title: "Hunt",
                img: "040A4794.jpg",
                desc: "A thrilling encounter awaited us at the Masai Mara National Park. As we were about to enter the hotel, our guide spotted a pair of lions on a hunt. The climax came when a massive male lion emerged, carrying a wild boar cub in its jaws. This unforgettable moment, captured in a photograph, has earned me several awards.",
              },
              {
                title: "Peaceful",
                img: "_MG_1606.jpg",
                desc: "A trio of sloth bears, basking lazily on a rock, offered a serene sight at the Daroji Sloth Bear Sanctuary. Located just 15 kilometers from Hampi, this sanctuary provides a unique opportunity to witness these gentle giants in their natural habitat. This tranquil scene, captured on a sunny afternoon, is a testament to the beauty of nature.",
              },
            ].map((service, index) => (
              <div
                key={index}
                className="col-lg-4 col-md-6 col-sm-6"
                style={{ display: "flex" }}
              >
                <div
                  className="services-item"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "95%",
                    flex: 1,
                  }}
                >
                  <img
                    src={`img/services/${service.img}`}
                    alt={service.title}
                    style={{ flexShrink: 0, maxWidth: "100%", height: "auto" }}
                  />
                  <p style={{ fontWeight: "bold" }}>{service.title}</p>
                  <p style={{ textAlign: "justify", flexGrow: 1 }}>
                    {service.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="categories-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="section-title">
                <h2>Categories</h2>
                <p>
                  Moments, emotions, light, shadow, and perspectives converge in
                  every frame, transforming the ordinary into timeless art and
                  storytelling.
                </p>
              </div>
            </div>
          </div>
          <OwlCarousel
            className="categories-slider owl-carousel"
            {...options}
            style={{ cursor: "pointer" }}
          >
            <div
              className="cs-item"
              onClick={() => handleImageClick("Birdings")}
            >
              <div
                className="cs-pic set-bg"
                style={{ backgroundImage: "url(img/categories/birds.jpg)" }}
              ></div>
              <div className="cs-text">
                <h5>Birding</h5>
              </div>
            </div>
            <div
              className="cs-item"
              onClick={() => handleImageClick("BigCats")}
            >
              <div
                className="cs-pic set-bg"
                style={{ backgroundImage: "url(img/categories/bigcats.jpg)" }}
              ></div>
              <div className="cs-text">
                <h5>Big Cats</h5>
              </div>
            </div>
            <div
              className="cs-item"
              onClick={() => handleImageClick("WildLife")}
            >
              <div
                className="cs-pic set-bg"
                style={{ backgroundImage: "url(img/categories/wildlife.jpg)" }}
              ></div>
              <div className="cs-text">
                <h5>Wildlife</h5>
              </div>
            </div>
            <div
              className="cs-item"
              onClick={() => handleImageClick("Landscapes")}
            >
              <div
                className="cs-pic set-bg"
                style={{ backgroundImage: "url(img/categories/landscape.jpg)" }}
              ></div>
              <div className="cs-text">
                <h5>Landscape</h5>
              </div>
            </div>
            <div className="cs-item" onClick={() => handleImageClick("People")}>
              <div
                className="cs-pic set-bg"
                style={{ backgroundImage: "url(img/categories/people.jpg)" }}
              ></div>
              <div className="cs-text">
                <h5>Portrait </h5>
              </div>
            </div>
            <div
              className="cs-item"
              onClick={() => handleImageClick("Mobilography")}
            >
              <div
                className="cs-pic set-bg"
                style={{ backgroundImage: "url(img/categories/mobile.jpg)" }}
              ></div>
              <div className="cs-text">
                <h5>Mobilography</h5>
              </div>
            </div>
          </OwlCarousel>
        </div>
      </section>

      <section className="portfolio-section spad">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                {" "}
                <h2>Latest Clicks</h2>{" "}
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid" style={{ marginTop: "2rem" }}>
          <div className="row">
            <div className="col-lg-12 p-0">
              <div className="portfolio-filter">
                {filteredItems.map((item, index) => (
                  <div
                    key={index}
                    className={`pf-item set-bg ${item.class}`}
                    style={{
                      backgroundImage: `url(${item.image})`,
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <a
                      href={item.image}
                      className="pf-icon image-popup"
                      onClick={(e) => {
                        e.preventDefault();
                        openModal(item.image);
                      }}
                    >
                      <span className="icon_plus"></span>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      {isOpen && (
        <ReactImageLightbox
          mainSrc={currentImage}
          onCloseRequest={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default Home;
